import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactDOM from 'react-dom';
import CloseIcon from './img/CloseIcon';

const Popup = (props) => {
  const {
    children,
    className,
    show = false,
    staticBackdrop = false,
    withCloseBtn = false,
    onClose = () => {},
    onOpen = () => {},
  } = props;
  const [isOpen, setIsOpen] = useState(show);

  const popupRef = useRef();

  useEffect(() => {
    setIsOpen(show);
  }, [show]);

  const onClosePopup = (e) => {
    setIsOpen(false);
    onClose(false);
  }

  return (
    isOpen ? ReactDOM.createPortal(<div
        ref={popupRef}
        className={classNames('popup', className, isOpen ? 'show' : '')}
        onClick={!staticBackdrop ? onClosePopup : undefined}
      >
        <div className='content' onClick={(e) => e.stopPropagation()}>
          {withCloseBtn && (
            <CloseIcon className='close-btn' onClick={onClosePopup} />
          )}
          {children}
        </div>
      </div>, document.body)
    :
      null
  );
}

Popup.propTypes = {
  show: PropTypes.bool,
  staticBackdrop: PropTypes.bool,
  withCloseBtn: PropTypes.bool,
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
};

export default Popup;